import * as React from 'react';
import { TAdFoxBannerTemplate } from '@cian/adfox-component';

import { TBannerPlace } from '../../types/adfoxBanner';
import { AsideBanner } from './AsideBanner';
import { FooterBanner } from './FooterBanner';
import { deleteTextNode } from './helpers/deleteTextNode';
import { MainPageBanner } from './MainPageBanner';
import styles from './Wrapper.css';

export function connectBannerWrapper(Component: React.ComponentType<TAdFoxBannerTemplate>, className?: string) {
  return class Wrapper extends React.Component<TAdFoxBannerTemplate, {}> {
    public componentDidMount() {
      const container = document.getElementById(this.props.containerId);

      if (container) {
        /**
         * Удаляет текст, который Adfox автоматически вставляет в контейнер.
         * PS: Adfox вставляет json ответа запроса прямо в див.
         * Текст не получается удалить при помощи ref.
         */
        const observer = new MutationObserver(deleteTextNode);

        observer.observe(container, {
          childList: true,
          characterData: true,
        });
      }
    }

    public render() {
      return (
        <div id={this.props.containerId} className={styles[className || 'wrapper']}>
          <Component {...this.props} />
        </div>
      );
    }
  };
}

export function createTGBanner(place: TBannerPlace, className?: string) {
  switch (place) {
    case 'aside':
      return connectBannerWrapper(AsideBanner);
    case 'footer':
      return connectBannerWrapper(FooterBanner);
    case 'mainpage':
      return connectBannerWrapper(MainPageBanner, className);

    default:
      console.error('Передан не существующий тип баннера');

      return null;
  }
}
